export const defaultContainerModelData = {
  init: false,
  active: false
};

export const defaultModalModelData = {
  rendered: false
};

export const ContainerActionType = {
  ACTIVATE: `ACTIVATE`,
  DEACTIVATE: `DEACTIVATE`
};

export const ModalActionType = {
  RENDER: `RENDER`,
  DESTROY: `DESTROY`
};

export const CATEGORY_LIST_ANIMATION_DURATION = 100;
